module.exports = __webpack_public_path__ + "media/images/logo_alt_2-8b4afe87b5d35facc6dcbdaa646ddeea.svg";